module.exports = __webpack_public_path__ + "img/driving.eab3ffc9.svg";